// extracted by mini-css-extract-plugin
export var wrapper = "AboutHero-module--wrapper--tPAPF";
export var title = "AboutHero-module--title--Pkrl1";
export var hero = "AboutHero-module--hero--NA-NA";
export var blobArea = "AboutHero-module--blobArea--uTYAh";
export var blob = "AboutHero-module--blob--a7-V+";
export var image = "AboutHero-module--image--dt1Gf";
export var blob1 = "AboutHero-module--blob1--qt9VA";
export var blob2 = "AboutHero-module--blob2--W65eB";
export var blob3 = "AboutHero-module--blob3--az3Fe";